export enum DurationFormatEnums {
  T_24_HOURS,
  T_DECIMAL,
}
